var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarMake(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.564,
    height: 18,
    viewBox: "0 0 18.564 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 38267",
    style: {
      fill: "#fff",
      strokeLinecap: "round",
      opacity: 0.496
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.414 17.46a.62.62 0 0 1-.29-.071L33.61 14.98l-.236-.126-.235.126-4.51 2.408a.633.633 0 0 1-.661-.046.62.62 0 0 1-.25-.608l.866-5.157.043-.257-.186-.182-3.664-3.593a.629.629 0 0 1-.152-.641.621.621 0 0 1 .5-.42l5.05-.745.26-.038.116-.238L32.816.813A.623.623 0 0 1 33.937.81l2.261 4.653.116.238.26.038 5.052.745a.625.625 0 0 1 .345 1.065l-3.659 3.589-.186.182.043.257.865 5.154a.625.625 0 0 1-.62.729z",
    style: {
      stroke: "none"
    },
    transform: "translate(-24.095 .039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.375.96a.123.123 0 0 0-.11.072l-2.494 5.126-5.575.823a.118.118 0 0 0-.094.079.13.13 0 0 0 .032.134l4.03 3.953-.952 5.674a.12.12 0 0 0 .048.115.13.13 0 0 0 .134.012l4.981-2.66 4.984 2.66a.117.117 0 0 0 .055.013c.02 0 .048-.004.08-.027a.122.122 0 0 0 .047-.12l-.951-5.667 4.03-3.953a.13.13 0 0 0 .033-.13.124.124 0 0 0-.1-.084l-5.574-.822-2.493-5.13a.123.123 0 0 0-.11-.067m0-1c.432 0 .825.246 1.012.633l2.26 4.652 5.051.745a1.122 1.122 0 0 1 .626 1.912l-3.663 3.593.865 5.153a1.127 1.127 0 0 1-1.638 1.181l-4.514-2.408-4.51 2.408c-.38.2-.84.169-1.188-.08a1.12 1.12 0 0 1-.45-1.101l.865-5.153-3.664-3.593a1.13 1.13 0 0 1-.277-1.153c.133-.404.483-.7.904-.76l5.048-.744L32.366.594a1.12 1.12 0 0 1 1.01-.633z",
    style: {
      fill: "#272431",
      stroke: "none"
    },
    transform: "translate(-24.095 .039)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarMake);
export default __webpack_public_path__ + "static/media/star-make.18234f9d13ca9c6cc763f0362bfea69a.svg";
export { ForwardRef as ReactComponent };